import { Flex } from '../../../layouts/flex/Flex.js';
import { useGraphSize } from '../../core/components/chart-layout/hooks/useGraphSize.js';
import { useOverlay } from '../../core/components/overlay-tooltip/contexts/OverlayContext.js';
import { useTooltipData } from '../../core/components/overlay-tooltip/hooks/useTooltipData.js';
import { useSeriesActions } from '../../core/components/series-action/ChartSeriesActionContext.js';
import { isToolbarEnabled } from '../../core/utils/is-toolbar-enabled.js';
import { useHoneycombToolbarConfig } from '../hooks/use-honeycomb-toolbar-config.js';
import { useOverlayEvents } from '../hooks/use-overlay-events.js';
import { overlay as overlayClassName } from './HiveOverlay.sty.js';
import { HoneycombToolbar } from './toolbar/HoneycombToolbar.js';
import { HoneycombOverlayTooltip } from './tooltip/HoneycombOverlayTooltip.js';

export const HiveOverlay = () => {
  const toolbarConfig = useHoneycombToolbarConfig();
  const toolbarEnabled = isToolbarEnabled(toolbarConfig);
  const overlay = useOverlay();
  const eventHandlers = useOverlayEvents(overlay);
  const { height, width } = useGraphSize();
  const { chartSeriesActions } = useSeriesActions();
  const data = useTooltipData().data;

  const series = data?.series?.[0];
  const metadata = data?.metadata as { id: string } | undefined;

  return (
    <Flex
      className={overlayClassName}
      style={{
        height,
        width,
      }}
      data-testid="honeycomb-overlay"
      ref={overlay.overlayRef}
      {...eventHandlers}
    >
      <HoneycombOverlayTooltip
        actionsForItem={
          chartSeriesActions && series && metadata
            ? () => () =>
                chartSeriesActions({
                  id: metadata.id,
                  name: series.name,
                  values: [series.value],
                })
            : undefined
        }
      />
      {toolbarEnabled && <HoneycombToolbar />}
    </Flex>
  );
};
